import { makeAutoObservable } from 'mobx';

export class ForgottenPasswordMobxDto {
    email = '';

    constructor() {
        makeAutoObservable(this);
    }
}
